// eslint-disable-next-line jira/import-whitelist
import { fetchIssueGiraNonCriticalData } from '@atlassian/jira-issue-fetch-services/src/services/issue-gira-non-critical-data/index.tsx';
import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async ({ match }: RouterDataContext, _: ResourceStoreContext) => {
	const issueKey = getIssueKey(match);

	if (!issueKey || fg('move_iv_noncriticalgiraquery_out_of_critical_path')) {
		return null;
	}

	try {
		const data = await fetchIssueGiraNonCriticalData(issueKey);
		return data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.issue-view.gira-non-critical.getData',
				message: 'An error was thrown while prefetching issue gira non critical data',
				name: 'ResourceError',
			},
			error,
		);
	}
};
